<template>
  <div>
    <!-- 推广与使用页面 -->
    <div class="echart_zonglan">
      <div class="echarts_font">
        <img :src="icon_font"
             class="icon_img"
             alt="" />
        <span class="people_font">用户数统计</span>
      </div>
      <div id="echart_cjt_one">
        <UserLine v-if="userTotalData.villagerStatisList" :dataList="this.userTotalData.villagerStatisList"
                  class="user_line" />
        <div class="right_box">
          <div class="r_list"
               v-for="(item,index) in userTotalText"
               :key="index">
            <svg class="boder"
                 version="1.1"
                 id="Layer_1"
                 xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 x="0px"
                 y="0px"
                 width="100%"
                 height="100%"
                 viewBox="0 0 151 81"
                 enable-background="new 0 0 151 81"
                 xml:space="preserve">
              <image id="image0"
                     width="151"
                     height="81"
                     x="0"
                     y="0"
                     href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJcAAABRCAMAAADo8MTiAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEUAAAAN/f8N+/8R9voN
+v1Ix8cZ8PES+fsAqqoW8/YO+f0U8vUV8vIP+vwO/P8N/P////+5zx3vAAAADnRSTlMAdIzQjUCX
zwOs5Uw9nSd6A3MAAAABYktHRBCVsg0sAAAAB3RJTUUH5QsZDhwdX3MVGwAAAPtJREFUaN7t2tEO
gjAMQNFpRURw/v/fCgSkm32AB0JltwbXVEZOKpGZLEQV4dC4KMk1xDSkf41D/A6Sp3Muaao//Z0/
lSWak4b3t2LcelflLu64cOFyE7jO4woOXVX98OmKTl1Dv+qjEUZ47Reuc7i473GV6PL8fJSjEUZ4
7heu/3cJz6HNLvqFqzQX61VcJbq477e76BeuPV38T1sfnr9HXOtDnLq89ovnEK4SXaxXcZXoYv21
LRz/Tnjdb4ILFy4fgetMLrWZvBEZj3lQeVpulnJ+4pQb5caYr67+zPaTL9F2bTse86DytNwt5fzE
KTfKnTFfXf2l999/AGFh+qB6fZ1mAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTExLTI1VDExOjI4
OjI5KzAzOjAwyX7YewAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0xMS0yNVQxMToyODoyOSswMzow
MLgjYMcAAAAASUVORK5CYII=" />
            </svg>
            <div class="list_container">
              <div class="img_num">
                {{item.key}}
              </div>
              <div class="list_title">
                {{item.title}}
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

    <!-- 各栏目发帖 -->
    <div class="echart_zonglan">
      <div class="echarts_font">
        <img :src="icon_font"
             class="icon_img"
             alt="" />
        <span class="people_font">各栏目发帖量</span>
      </div>
      <div id="echart_cjt_two">
        <PostNum v-if="postTotalData.articleStatisList.length>0" :dataList="this.postTotalData.articleStatisList" class="post_num" />
        <div class="compantBtn">
          <div class="btnBox">
            <div v-for="(item, index) in menuPostList"
                 :key="index"
                 :class="[isPostActive == index ? 'activeBtn' : 'btn']"
                 @click="selectPostNumBtn(index)">
              <p class="btnTitle">{{ item.title }}</p>
            </div>
          </div>
        </div>
        <div class="right_box"
             style="margin-top: 8rem;padding: 0px 20px 5px 8px;">
          <div class="r_list" v-for="(item,index) in postTotalText" :key="index">
            <svg class="boder"
                 version="1.1"
                 id="Layer_1"
                 xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 x="0px"
                 y="0px"
                 width="100%"
                 height="100%"
                 viewBox="0 0 151 81"
                 enable-background="new 0 0 151 81"
                 xml:space="preserve">
              <image id="image0"
                     width="151"
                     height="81"
                     x="0"
                     y="0"
                     href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJcAAABRCAMAAADo8MTiAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEUAAAAN/f8N+/8R9voN
+v1Ix8cZ8PES+fsAqqoW8/YO+f0U8vUV8vIP+vwO/P8N/P////+5zx3vAAAADnRSTlMAdIzQjUCX
zwOs5Uw9nSd6A3MAAAABYktHRBCVsg0sAAAAB3RJTUUH5QsZDhwdX3MVGwAAAPtJREFUaN7t2tEO
gjAMQNFpRURw/v/fCgSkm32AB0JltwbXVEZOKpGZLEQV4dC4KMk1xDSkf41D/A6Sp3Muaao//Z0/
lSWak4b3t2LcelflLu64cOFyE7jO4woOXVX98OmKTl1Dv+qjEUZ47Reuc7i473GV6PL8fJSjEUZ4
7heu/3cJz6HNLvqFqzQX61VcJbq477e76BeuPV38T1sfnr9HXOtDnLq89ovnEK4SXaxXcZXoYv21
LRz/Tnjdb4ILFy4fgetMLrWZvBEZj3lQeVpulnJ+4pQb5caYr67+zPaTL9F2bTse86DytNwt5fzE
KTfKnTFfXf2l999/AGFh+qB6fZ1mAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTExLTI1VDExOjI4
OjI5KzAzOjAwyX7YewAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0xMS0yNVQxMToyODoyOSswMzow
MLgjYMcAAAAASUVORK5CYII=" />
            </svg>
            <div class="list_container">
              <div class="img_num">
                {{item.key}}
              </div>
              <div class="list_title">
                {{item.title}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 各栏目访问 -->
    <div class="echart_zonglan">
      <div class="echarts_font">
        <img :src="icon_font"
             class="icon_img"
             alt="" />
        <span class="people_font">各栏目访问量</span>
      </div>
      <div id="echart_cjt_two">
        <VisitsNum v-if="visitsTotalData.articleStatisList.length>0" :dataList="this.visitsTotalData.articleStatisList" class="visits_num" />
        <div class="compantBtn">
          <div class="btnBox">
            <div v-for="(item, index) in menuVisitsList"
                 :key="index"
                 :class="[isVisitsActive == index ? 'activeBtn' : 'btn']"
                 @click="selectVisitsNumBtn(index)">
              <p class="btnTitle">{{ item.title }}</p>
            </div>
          </div>
        </div>
        <div class="right_box"
             style="margin-top: 8rem;padding: 0px 20px 5px 8px;">
          <div class="r_list" v-for="(item,index) in visitsTotalText" :key="index">
            <svg class="boder"
                 version="1.1"
                 id="Layer_1"
                 xmlns="http://www.w3.org/2000/svg"
                 xmlns:xlink="http://www.w3.org/1999/xlink"
                 x="0px"
                 y="0px"
                 width="100%"
                 height="100%"
                 viewBox="0 0 151 81"
                 enable-background="new 0 0 151 81"
                 xml:space="preserve">
              <image id="image0"
                     width="151"
                     height="81"
                     x="0"
                     y="0"
                     href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJcAAABRCAMAAADo8MTiAAAABGdBTUEAALGPC/xhBQAAACBjSFJN
AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAM1BMVEUAAAAN/f8N+/8R9voN
+v1Ix8cZ8PES+fsAqqoW8/YO+f0U8vUV8vIP+vwO/P8N/P////+5zx3vAAAADnRSTlMAdIzQjUCX
zwOs5Uw9nSd6A3MAAAABYktHRBCVsg0sAAAAB3RJTUUH5QsZDhwdX3MVGwAAAPtJREFUaN7t2tEO
gjAMQNFpRURw/v/fCgSkm32AB0JltwbXVEZOKpGZLEQV4dC4KMk1xDSkf41D/A6Sp3Muaao//Z0/
lSWak4b3t2LcelflLu64cOFyE7jO4woOXVX98OmKTl1Dv+qjEUZ47Reuc7i473GV6PL8fJSjEUZ4
7heu/3cJz6HNLvqFqzQX61VcJbq477e76BeuPV38T1sfnr9HXOtDnLq89ovnEK4SXaxXcZXoYv21
LRz/Tnjdb4ILFy4fgetMLrWZvBEZj3lQeVpulnJ+4pQb5caYr67+zPaTL9F2bTse86DytNwt5fzE
KTfKnTFfXf2l999/AGFh+qB6fZ1mAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIxLTExLTI1VDExOjI4
OjI5KzAzOjAwyX7YewAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMS0xMS0yNVQxMToyODoyOSswMzow
MLgjYMcAAAAASUVORK5CYII=" />
            </svg>
            <div class="list_container">
              <div class="img_num">
                {{item.key}}
              </div>
              <div class="list_title">
                {{item.title}}
              </div>
            </div>
          </div>
   
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 用户数统计图表
import UserLine from "../detail_cjt_echart/user_line.vue";
// 发帖量图表
import PostNum from "../detail_cjt_echart/post_num.vue";
// 访问量图表
import VisitsNum from "../detail_cjt_echart/visits_num.vue";
import { log } from "three";
export default {
  name: "PromotionUse",
  components: {
    UserLine,
    PostNum,
    VisitsNum,
  },
  data() {
    return {
      icon_font: require("@/assets/images/icon_font.png"),
      // 各栏目发帖量 按钮列表
      menuPostList: [{ title: "累计发帖量" }, { title: "当月发帖量" }],
      // 各栏目访问量 按钮列表
      menuVisitsList: [{title: "累计访问量" }, {title: "当月访问量" }],
      isPostActive: 0,
      isVisitsActive: 0,

      // 用户数统计 关注、当月新增、活跃、图表数据
      userTotalData: {
        numSum: 0,
        monthNumSum: 0,
        activeNumSum: 0,
        villagerStatisList: [],
      },
      userTotalText: [
        {
          title: "关注用户数统计",
        },
        {
          title: "当月新增用户数统计",
        },
        {
          title: "活跃用户数统计",
        },
      ],

      // 发帖量统计

      postTotalData: null,
      postTotalText: [
        {
          title: "村居简介",
        },
        {
          title: "党务村务",
        },
        {
          title: "网上地摊",
        },
      ],
      // 访问量统计

      visitsTotalData: {
        villageGuideSum: 0,
        openPartyAffairsSum: 0,
        villageAffairsSum: 0,
        employDemandSum: 0,
        articleStatisList	: [],
      },
      visitsTotalText: [
        {
          title: "村居简介",
        },
        {
          title: "党务村务",
        },
        {
          title: "网上地摊",
        },
      ],

    };
  },

  created() {
    this.handleUserTotal();
    this.handlePostTotal('1')
    this.handleVisitTotal('1')
  },
  mounted() {},
  methods: {
    // 各栏目发帖量 选择按钮
    selectPostNumBtn(index) {
      this.isPostActive = index;
      this.handlePostTotal(index+1)
    },
    // 各栏目访问量 选择按钮
    selectVisitsNumBtn(index) {
      this.isVisitsActive = index;
      this.handleVisitTotal(index+1)
    },
    // 用户数统计
    handleUserTotal() {
      this.userTotalData = plOtherDataInterface.getVillagerNum();
      this.userTotalText.map((item) => {
        if (item.title === "关注用户数统计") {
          item.key = this.userTotalData.numSum;
        }
        if (item.title === "当月新增用户数统计") {
          item.key = this.userTotalData.monthNumSum;
        }
        if (item.title === "活跃用户数统计") {
          item.key = this.userTotalData.activeNumSum;
        }
      });
    },
    // 发帖统计
    handlePostTotal(index) {
      this.postTotalData = plOtherDataInterface.getArticlePostsNum(index);
      this.postTotalText.map((item) => {
        if (item.title === "村居简介") {
          item.key = this.postTotalData.villageGuideSum;
        }
        if (item.title === "党务村务") {
          item.key = this.postTotalData.openPartyAffairsSum;
        }
        if (item.title === "网上地摊") {
          item.key = this.postTotalData.onlineStallSum;
        }
      });
    },

     // 访问统计
    handleVisitTotal(index) {
      this.visitsTotalData= null
      this.visitsTotalData = plOtherDataInterface.getArticleReadNum(index);
      this.visitsTotalText.map((item) => {
        if (item.title === "村居简介") {
          item.key = this.visitsTotalData.villageGuideSum;
        }
        if (item.title === "党务村务") {
          item.key = this.visitsTotalData.openPartyAffairsSum;
        }
        if (item.title === "网上地摊") {
          item.key = this.visitsTotalData.onlineStallSum;
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
.echart_zonglan {
  margin: 1.875rem 0 0 0;
  padding-top: 0.888rem;
  padding-bottom: 0.888rem;
  border-bottom: 1px dashed rgb(121, 226, 154);
  &:last-child {
    border-bottom: none;
  }
}

#echart_cjt_one,
#echart_cjt_two,
#echart_cjt_three {
  display: flex;
  .user_line,
  .post_num,
  .visits_num {
    margin-top: 1rem;
    width: 78%;
    height: 22rem;
  }
  .post_num {
    margin-top: 5rem;
    height: 25rem;
  }
  .visits_num {
    margin-top: 5rem;
    height: 25rem;
  }

  .right_box {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    box-sizing: border-box;
    height: 100%;
    width: 22%;
    padding: 20px 20px 20px 8px;
    .r_list {
      position: relative;
      .border {
        position: absolute;
        top: 0;
        left: 0;
      }
      .list_container {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        align-items: center;
        width: 100%;
        height: 100%;
        z-index: 99;
        position: absolute;
        top: 0;
        left: 0;
        box-sizing: border-box;
        padding: 13px 10px 10px 10px;
        .img_num {
          display: flex;
          align-items: center;
          justify-content: center;
          color: #ffffff;
          width: 100%;
          overflow: hidden;
          height: 2rem;
          font-size: 2rem;
          background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKMAAAAgCAYAAAB+SMj2AAAABHNCSVQICAgIfAhkiAAABRlJREFUeF7tXLtW4zAQtc/BxRZLAwXFNtvwCfn/ahuabShoaChS4P2CUOxEyiDLHl2PRlYwiZ0DIollvcZX986MaR/7P7sGHh/NDb0+6CWVDX2eOjr64kCvjl5yiRoW6nV0nQN9TiX90dBljw0kSn8enx+XqB6Ns6PxHlAp1MeTuH2rmIH2sX/a8XqClaUF9wZwQ8UHVZDKhhawoYWUyk/7YTuKyqGBiSdw82LpDTO/XmzYcn3reN2Nsh1ZM9D+JmOUayBEY0iSa5I5mpDUX83ebhKJPxHSiqQaJN6QNMvyhJPJGP+SMSb3usEWmz4L1bcji0dYhKg1EdHaLhovb/1oB7lmRG1/OWP0RxnHw/W9waIDcVNcs6zfiJsiJGVmUIObXicnJWN8FpERaYNgGghRl0dS5qpWboqQlCHYioilnNi6g7h2S/fHldRvH/bPOz8RR3HSEdejkjCSS81QETKh+mWIRiKqGjc1InExN8VI7Nfpcrlp+9C/EDIe3TN+af1vfheXCBGD+8aGiKVIXIQsaTHuANPKTTESe8OzIrGdm64EBiUBc0fI2JE75uDEQij9VijfqQhJNYhqRVLff7vaRkjq/ajosLeb7HcxkrIfFSHq90HS9q5/dZxRh0xTzAyOcISoVm7JxjGtX4rEGEmpXTchNr+pFUnZXWqtr0Fi6w5yDpXf3u5fCBl1kQ2/pcQImo2oI05aiqQc2bFy03lOvEWgphGpARIvuOs7ZEzhltX/GPqXYp9z3LSe3xPvAOl2a0agLlHlW5C0/bF/dciIYr3+a9mfNh8jZpIuI2oZNzWq3k9SItffVP44po9VPlOadExfqC8JmNv+bRe4CnOlkcwbRGgQVytX2whJOVljyk1Ru6zCrIhYl5umOSnH+K1q21qv1N9qV/k3DSHj2y6lXqyIGE9EPqIiboqQlMfhJqQKN62DxGUqvzTytZ4IVNu8v/9cjoP+o0vd0U8o7+l9T+/v6dOefoblcu1+1ZXGIwrv41mIZ+Wrelve7nR9eWTS+vJsaNtd2BiPzaY7HJZE7t4SA9IOfLnz0gYZbj25NWSwPIvL9XOpK9nXl3uQWue26/udpOZcaHA2f5E55pT7BAf6NIARKCjipiiSw8PK8z+Wq3xbu5p8UZ2fV1D7VfNMvfis6fccUrq22fekpoft5XM8FDONHceyKivjpqi/Gi9BDZWP8z23CNQp838UgXLG6O73k0UGB3gGog0yrRGiBkTMQ9JkZGIBla9T25vKH2fwW9U6qheMMYdSnG58K6LF8l+OnSLVbG2X1ba1/npVfk0kPl8EymaMIpKGoP34kZQkR+S0tQQ3RUga/HCc3KFAciWS6jgeP2Q25bbl3NQWgQrtWnMB0vV0GqIslm83xhwkPZ2LuGlMkmVuOc9NESfFmdnfLQI1H1O3+x+/KgJ1VmNcgpvq7tDvpfIDEltj+WmVr+PENiTV7CA5WULnN8YMRF1G5fNjtTE3ra/yS5E4X+XXjEDVRGKOQK3aGLVIOhtbL+CmyF+abFfJTcs5Hl9hPXmmJUi8fmPMQFI+dV4ty/7H+ipf4/fM9/MukmdqfgbKngE/5qYXaYxaRLWqfN1TipvKHzNRnB/bNJdrjCKiyv64+iqf/+VLrPZLObF1B4j9rfnctNYzUFdmjGDPv9IIlC5f8zwRqM0YDZy0NJJTn5vW9LfmI6lW5W/GaDFGZSy/psrXZYKzv/WUHaVU+Rr/oS7LKE/l/wc6wKiRyprZOwAAAABJRU5ErkJggg==");
        }
        .list_title {
          font-size: 1rem;
          line-height:1;
          color: #ffffff;
        }
      }
    }
  }
}

#echart_cjt_one {
  align-items: center;
}

#echart_cjt_two {
  position: relative;
}
.compantBtn {
  position: absolute;
  right: 5%;
  top: 0;
}

.echarts_font {
  text-align: left;
}
.icon_img {
  width: 25px;
  height: 25px;
  margin-right: 0.4375rem;
  vertical-align: sub;
}
.people_font {
  font-size: 24px;
  color: rgb(62, 248, 156);
}
.text-center {
  text-align: center;
  font-size: 16px;
  color: #d3d3d3;
}
::-webkit-scrollbar {
  background-color: #15606e;
  width: 5px;
} /* 这是针对缺省样式 (必须的) */
::-webkit-scrollbar-thumb {
  background: #00574a;
  width: 5px;
  border-radius: 10px;
} /* 滑块颜色 */

.companySelect {
  padding-top: 2rem;
}
// 下拉选择框样式
.selectLable {
  width: 90px;
  height: 25px;
  font-size: 16px;
  font-family: PingFang-SC-Medium;
  text-align: center;
  color: #ffffff;
  line-height: 18px;
  margin-right: 5px;
}
.el-select {
  width: 151px;
  border-radius: 4px;
}
.el-select,
/deep/ .el-input,
/deep/ .el-input__inner {
  background: rgba(138, 206, 254, 0.3);
  text-align: center;
  color: ghostwhite;
  font-size: 16px;
  height: 30px;
}
.el-select /deep/ .el-select-dropdown__item.selected {
  color: rgb(62, 248, 156);
}
.el-select /deep/ .el-select__caret {
  /*很关键：将默认的select选择框样式清除*/
  appearance: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  /*为下拉小箭头留出一点位置，避免被文字覆盖*/
  /*自定义图片*/
  background: url("../../../assets/icon/selectIcon.png") no-repeat scroll right
    center transparent;
  /*自定义图片的大小*/
  background-size: 12px 12px;
}
/*将小箭头的样式去去掉*/
.el-select /deep/ .el-icon-arrow-up:before {
  content: "";
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.btnBox {
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}
.btn {
  width: 160px;
  height: 30px;
  background: rgba(18, 87, 123, 0.6);
  border: 1px solid #00ffce;
  text-align: center;
  cursor: pointer;
  margin-right: 13px;
}
.activeBtn {
  width: 160px;
  height: 30px;
  background: linear-gradient(0deg, #2dbcdd, #09809c 78%, #2dbcdd);
  border: 1px solid #00ffff;
  text-align: center;
  cursor: pointer;
  margin-right: 13px;
}
.btnTitle {
  font-size: 16px;
  font-family: inpinheiti;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 2px;
}
.companyText {
  margin-top: 22px;
  word-break: break-all;
  width: 930px;
  height: auto;
  margin: 0 auto;
}
.companyImg {
  width: 384px;
  height: 289px;
  float: left;
  margin-right: 30px;
}
.companyP {
  font-size: 16px;
  font-family: AdobeHeitiStd-Regular;
  color: #ffffff;
  line-height: 30px;
  letter-spacing: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/rightAside/detail_cjt/promotion_use.vue